export default __webpack_public_path__ + "static/compareItemImg2-da1494c45f6b5e5d0521ddb3578127ac.webp";